import type { InputTokens, SemanticTokens, RadiusScale, SpacingScale } from '@/theme/types'

export const createInputTokens = (
  semantic: SemanticTokens,
  radius: RadiusScale,
  _spacing: SpacingScale,
): InputTokens => ({
  height: 40,
  borderRadius: radius.md,
  borderColor: semantic.colors.border,
  borderColorFocus: semantic.colors.primary,
  background: semantic.surface.surface,
})

